module.exports = __webpack_public_path__ + "static/img/icon_setting.0ad0bc79.svg";